import React from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import CustomToolTip from '../../../../common/components/UI/ToolTip/ToolTip';
import clsx from 'clsx';

const StyledButton = styled(Button)(({ theme }) => ({
        fontSize: '14px',
        fontWeight: '500',
        backgroundColor: theme.colors.primary[500],
        color: 'white',
        textTransform: 'inherit',
        padding: '0 14px',
        borderRadius: '4px',
        textAlign: 'left',
        minWidth: '32px',
        overflow: 'hidden',
        '&:hover': {
            backgroundColor: theme.colors.primary[400]
        },
        '& svg': {
            maxWidth: '20px',
            marginRight: '6px'
        },
        '&.primary': {
            boxShadow: '0px 4px 8px ' + theme.colors.primary[500] + '40',
            backgroundColor: theme.buttons.primary.default.background,
            color: theme.buttons.primary.default.text,
            border: '1px solid ' + theme.buttons.primary.default.border,
            '& svg': {
                '& path': {
                    'fill': theme.buttons.primary.default.svg
                }
            },
            '&:hover': {
                backgroundColor: theme.buttons.primary.hover.background,
                color: theme.buttons.primary.hover.text,
                border: '1px solid ' + theme.buttons.primary.hover.border,
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.primary.hover.svg
                    }
                },
            },
            '&:active': {
                backgroundColor: theme.buttons.primary.active.background,
                color: theme.buttons.primary.active.text,
                border: '1px solid ' + theme.buttons.primary.active.border,
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.primary.active.svg
                    }
                },
            },
            '&:disabled': {
                backgroundColor: theme.buttons.primary.disabled.background,
                color: theme.buttons.primary.disabled.text,
                border: '1px solid ' + theme.buttons.primary.disabled.border,
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.primary.disabled.svg
                    }
                },
            },

        },
        '&.secondary': {
            backgroundColor: theme.buttons.secondary.default.background,
            color: theme.buttons.secondary.default.text,
            border: '1px solid ' + theme.buttons.secondary.default.border,
            '& svg': {
                '& path': {
                    'fill': theme.buttons.secondary.default.svg
                }
            },
            '&:hover': {
                backgroundColor: theme.buttons.secondary.hover.background,
                color: theme.buttons.secondary.hover.text,
                border: '1px solid ' + theme.buttons.secondary.hover.border,
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.secondary.hover.svg
                    }
                },
            },
            '&:active': {
                backgroundColor: theme.buttons.secondary.active.background,
                color: theme.buttons.secondary.active.text,
                border: '1px solid ' + theme.buttons.secondary.active.border,
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.secondary.active.svg
                    }
                },
            },
            '&:disabled': {
                backgroundColor: theme.buttons.secondary.disabled.background,
                color: theme.buttons.secondary.disabled.text,
                border: '1px solid ' + theme.buttons.secondary.disabled.border,
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.secondary.disabled.svg
                    }
                },
            }
        },
        '&.tertiary': {
            border: '1px solid ' + theme.buttons.tertiary.default.border,
            '&:hover': {
                border: '1px solid ' + theme.buttons.tertiary.hover.border,
            },
            '&:active': {
                border: '1px solid ' + theme.buttons.tertiary.active.border,
            },
            '&:disabled': {
                border: '1px solid ' + theme.buttons.tertiary.disabled.border,
            }
        },
        '&.small': {
            fontSize: '12px',
            height: '32px',
            lineHeight: '32px'
        },
        '&.medium': {
            fontSize: '14px',
            height: '41px',
            lineHeight: '41px'
        },
        '&.large': {
            fontSize: '14px',
            height: '48px',
            lineHeight: '48px',
            padding: '0 24px'
        },
        '&.full': {
            fontSize: '14px',
            height: '48px',
            lineHeight: '48px',
            padding: '0 24px',
            width: '100%'
        },
}));


const CustomButton = (props) => {
    const { onClick, size, color, className, children, tooltip, ...other } = props;
    let button =
        <StyledButton
            onClick={onClick}
            className={clsx(size, color, className)}
            {...other}
        >
            {children}
        </StyledButton>

    return (
        tooltip !== undefined ?
            <CustomToolTip
            titleText={tooltip}
                jsx={
                    button
                }
            /> : button

    )
}
export default CustomButton;

